/**
 * cssプロパティで使用する値に単位を付けて返却する（100, "100", "100px" -> "100px"）
 * @param v 単位付き、または単位なしのcssプロパティで使用する値
 * @returns paramが単位付き値の場合何もせず値を返却、単位なし値の場合は末尾にpxを追加して文字列として返す
 */
var t=t=>"string"==typeof t&&/%|px|em|vh|vw/.test(t)?t:"".concat(t,"px");export{t as addUnit};
